import { lazy } from "react";
import {
  KEY_EQUIPEMENT,
  TITLE_EQUIPEMENT,
  PATH_EQUIPEMENT,
  PATH_EQUIPEMENT_LOT_TRACKER,
  KEY_EQUIPEMENT_LOT_TRACKER,
  TITLE_EQUIPEMENT_LOT_TRACKER,
  PATH_EQUIPEMENT_TRACKER,
  KEY_EQUIPEMENT_TRACKER,
  TITLE_EQUIPEMENT_TRACKER,
} from "layouts/equipement/constant/path";

import { buildRouteItem } from "router/routesUtils";

const LotTracker = lazy(() => import("layouts/equipement/rubrique/lot_tracker"));
const Tracker = lazy(() => import("layouts/equipement/rubrique/tracker"));

const EQUIPEMENT_MENU_ITEMS = [
  {
    title: TITLE_EQUIPEMENT_LOT_TRACKER,
    key: KEY_EQUIPEMENT,
    path: PATH_EQUIPEMENT,
    component: LotTracker,
  },
  {
    title: TITLE_EQUIPEMENT_LOT_TRACKER,
    key: KEY_EQUIPEMENT_LOT_TRACKER,
    path: PATH_EQUIPEMENT_LOT_TRACKER,
    component: LotTracker,
  },
  {
    title: TITLE_EQUIPEMENT_TRACKER,
    key: KEY_EQUIPEMENT_TRACKER,
    path: PATH_EQUIPEMENT_TRACKER,
    component: Tracker,
  },
];

const ROUTES_EQUIPEMENT = [
  buildRouteItem(
    TITLE_EQUIPEMENT,
    KEY_EQUIPEMENT,
    PATH_EQUIPEMENT,
    EQUIPEMENT_MENU_ITEMS,
    "settings"
  ),
];
export default ROUTES_EQUIPEMENT;
